import "./CouponInformation.css"
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import CouponsService from "../../../../../services/CouponsService";
import UserService from "../../../../../services/UserService";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../../../../context/AuthContext";
import {useAccount} from "../../../../../context/AccountContext";

const CouponInformationComponent = ({wrapped, userData, showCouponSection, showCurrentCoupons}) => {
    const {t} = useTranslation()
    const couponsFiltered = userData?.couponsInformation?.filter(item => item.discount_type !== "amount").slice(userData?.subscription?.coupon_uses_allowed - userData?.subscription?.coupon_use_count ? 0 : 1)
    showCurrentCoupons = showCurrentCoupons && couponsFiltered.length

    let account = useAccount();

    const {setCheckLoggedIn} = useAuth();

    const navigate = useNavigate()
    const onCashCoupon = () => {
        setCheckLoggedIn(false);
        navigate("/CashCoupon");
    };

    return (
        <>
            {showCouponSection ?
                <>
                    <div className={`coupon-section${wrapped ? " wrapped":""}`}>
                        {showCurrentCoupons && couponsFiltered.length ?
                            <div className={"coupon-heading"}>
                                <span className={"coupon-header"}>
                                    {t("accountCouponTitle")}
                                </span>
                                <button className={"coupon-header-cta"} onClick={onCashCoupon}>
                                    {t("accountAddNewCoupon")}
                                </button>
                            </div>:
                            <>
                                <div className={"coupon-heading single"}>
                                    <span className={"coupon-header"}>{t("accountCouponGotCoupon")}</span>
                                </div>
                            </>
                        }
                        {showCurrentCoupons && couponsFiltered.length ?
                                <div className={"coupon-data"}>
                                    {couponsFiltered.map((item, index) => {
                                        return (
                                            <div key={index} className={`coupon-item`}>
                                                <span title={item?.description}>
                                                    {item?.description}
                                                </span>
                                            </div>)
                                    })}
                                </div>
                            :
                            <>
                                <div className={"coupon-input-wrapper"}>
                                    <AccountEnterCoupon account={account} navigate={navigate}/>
                                </div>
                            </>
                        }
                    </div>
                </>
                :
                <></>
            }
        </>)
}

function AccountEnterCoupon({account, navigate}) {
    const [coupon, setCoupon] = useState("");
    const {t} = useTranslation();
    const [error, setError] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [disabledButton, setDisabledButton] = useState(true);

    const handleChange = (e) => {
        e.preventDefault();
        setInputError(false);
        //setDisabledButton(e.target.value.length !== 16);
        setDisabledButton(e.target.value.replace(/\s/g, "").length === 0);
        setCoupon(e.target.value);
        setError(false);
    };

    const onValidateCoupon = (e) => {
        e.preventDefault();
        setDisabledButton(true);
        CouponsService.checkCouponValidity(coupon)
            .then((response) => {
                setError(false);
                sessionStorage.setItem("discount-coupon", coupon);
                if (UserService.isLoggedIn()) {
                    navigate("/PickProgram");
                } else {
                    // console.debug("Retrying authorization")
                    try {
                        UserService.doLogin(process.env.REACT_APP_ENTER_COUPON_REDIRECT_URI);
                    } catch (e) {
                        // console.debug("Error slow connection")
                    }
                }
            })
            .catch((error) => {
                setError(true);
            })
            .finally(() => {
                setDisabledButton(false);
            });
    };
    return (<div id="account-enter-coupon">
        <form autoComplete="off" onSubmit={onValidateCoupon} className={"account-coupon-wrapper"}>
            <div className={"account-coupon-inner-wrapper"}>
                <div className={`account-coupon-textbox-wrapper ${error || inputError ? "account-coupon-error" : ""}`}>
                    <div className={"account-coupon-input"}>
                        <input type={"text"} placeholder={t("accountCouponTypeCode")} onChange={handleChange}
                               value={coupon}/>
                    </div>
                    <button type={"submit"}
                            disabled={disabledButton}
                    >
                        <div className={"account-coupon-textbox-button"}></div>
                    </button>
                </div>
                {(error || inputError) &&
                    <span>{t("accountCouponInvalidCode")}</span>
                }
            </div>
        </form>
    </div>)
}
export default CouponInformationComponent;